import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import PrivacyConsentDocument from '../../../privacy/PrivacyConsentDocument';

export default function ConsentAgreementContent() {
  const { t, i18n } = useTranslation('app');
  const language = String(i18n.resolvedLanguage || i18n.language || 'ko')
    .trim().toLowerCase().replace(/_/g, '-').split('-')[0];
  const fileName = language === 'ko'
    ? 'PrivacyConsentForm_V1.0.json'
    : `PrivacyConsentForm_V1.0_${language}.json`;
  const [result, setResult] = useState(null);
  const [retryCount, setRetryCount] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    setResult(null);

    async function loadDocument() {
      try {
        const publicUrl = String(process.env.PUBLIC_URL || '').replace(/\/+$/, '');
        const response = await fetch(`${publicUrl}/PrivacyConsent/${fileName}`, {
          signal: controller.signal,
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error(`Privacy consent request failed: ${response.status}`);
        const data = await response.json();
        if (!data?.document_info || !Array.isArray(data.privacy_policy_chapters)) {
          throw new Error('Invalid privacy consent document');
        }
        if (!controller.signal.aborted) setResult({ fileName, data });
      } catch (error) {
        if (!controller.signal.aborted) setResult({ fileName, error: true });
      }
    }

    loadDocument();
    return () => controller.abort();
  }, [fileName, retryCount]);

  if (!result || result.fileName !== fileName) {
    return <p role="status">{t('privacyPolicy.loading')}</p>;
  }

  if (result.error) {
    return (
      <div role="alert">
        <p>{t('privacyPolicy.loadFailed')}</p>
        <button type="button" onClick={() => setRetryCount((count) => count + 1)}>
          {t('privacyPolicy.retry')}
        </button>
      </div>
    );
  }

  return <PrivacyConsentDocument documentData={result.data} />;
}
